module.exports = __webpack_public_path__ + "img/ci22-convid19-fg.459ff9a1.png";